import { combineReducers } from 'redux';

import { ccassConstants } from '../constants';
import { CCASSStatisticsResponseBody } from '../shared/types';

type StatisticsState = Partial<CCASSStatisticsResponseBody> & {
  loading?: boolean;
  error?: Error;
  when?: string;
};
const statistics = (state: StatisticsState = {}, action): StatisticsState => {
  switch (action.type) {
    case ccassConstants.STATISTICS_REQUEST: {
      return {
        loading: true,
        statistics: state.statistics,
      };
    }
    case ccassConstants.STATISTICS_SUCCESS: {
      return {
        statistics: action.statistics,
        when: action.when,
        updatedAt: action.updatedAt,
      };
    }
    case ccassConstants.STATISTICS_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

const detailStatistics = (state: any = {}, action) => {
  switch (action.type) {
    case ccassConstants.DETAIL_STATISTICS_REQUEST: {
      return {
        loading: true,
        statistics: state.statistics,
      };
    }
    case ccassConstants.DETAIL_STATISTICS_SUCCESS: {
      return {
        statistics: action.statistics,
        when: action.when,
        updatedAt: action.updatedAt,
      };
    }
    case ccassConstants.DETAIL_STATISTICS_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

export default combineReducers({
  statistics,
  detailStatistics,
});
